<template lang="html">
  <div v-if="show" class="loader-wrapper">
    <img :src="require('@/assets/images/loader.gif')" alt="">
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'loader',
  data () {
    return {
      show: false
    }
  },
  mounted () {
    eventBus.$on('showLoader', (data) => {
      this.show = data
    })
  }
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  overflow: hidden;

  img {
    height: 70px;
    width: 70px;
  }
}
</style>
